export type LocCodesInput = {
  locCode?: number | null;
  locCodes?: number | number[] | null;
};

export function normalizeLocCodes({ locCode, locCodes }: LocCodesInput): number[] {
  if (locCodes != null) {
    const codes = (Array.isArray(locCodes) ? locCodes : [locCodes])
      .map(Number)
      .filter((code) => !Number.isNaN(code));

    if (codes.length) return codes;
  }

  if (locCode != null) {
    const code = Number(locCode);
    if (!Number.isNaN(code)) return [code];
  }

  throw new Error("locCode or locCodes is required");
}

export function getEpidemiologyExportFilename(locCodes: number[]) {
  return locCodes.length === 1 ? `epidemiology_${locCodes[0]}.zip` : "epidemiology_export.zip";
}

export function getPrevProjExportFilename(locCodes: number[]) {
  return locCodes.length === 1 ? `prev_proj_${locCodes[0]}.zip` : "prev_proj_export.zip";
}
